/**
    Store details should be used anytime brief store information is displayed on the page, including address,
    my store indicator and make an appointment CTA.
*/

import React from 'react';
import { connect } from 'react-redux';
import { StoreDetailProps } from 'util/Props';
import MazamaStoreDetailsBrief from 'components/MazamaStoreDetailsBrief';
import {
    addStoreDetails,
    postMyStore,
    setSelectedStore
} from '../actions/Global';
class MazamaStoreDetails extends React.Component {
    constructor(props) {
        super(props);
        this.addStoreDetails = this.addStoreDetails.bind(this);
        this.postMyStore = this.postMyStore.bind(this);
        this.setSelectedStore = this.setSelectedStore.bind(this);
    }
    addStoreDetails(details) {
        this.props.dispatch(addStoreDetails(details));
    }
    postMyStore(url, id) {
        this.props.dispatch(postMyStore(url, id));
    }
    setSelectedStore(id) {
        this.props.dispatch(setSelectedStore(id));
    }
    render() {
        return (
            <MazamaStoreDetailsBrief
                {...(this.props.useUserStore
                    ? Object.assign(this.props, this.props.userStore)
                    : this.props)}
                isSelectedStore={this.props.selectedStore === this.props.id}
                setSelectedStore={this.setSelectedStore}
                handleMount={this.addStoreDetails}
                postMyStore={this.postMyStore}
                noMap={this.props.noMap}
            />
        );
    }
}

MazamaStoreDetails.propTypes = StoreDetailProps;
MazamaStoreDetails.defaultProps = {
    noMap: false,
    useUserStore: true
};

const mapStateToProps = state => ({
    myStore: state.globalState.myStore,
    userStore: state.globalState.userStore,
    selectedStore: state.globalState.selectedStore
});

export default connect(mapStateToProps)(MazamaStoreDetails);
